import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface ChatMessage {
	role: 'user' | 'assistant';
	content: string;
}

/**
 * Talks to the backend AI proxy, which forwards the conversation to MiniMax-M3
 * using the server-held API key. The token never reaches the browser.
 *
 * Expected backend contract:
 *   POST {baseURLV2}/ai/chat
 *   body     { model: 'MiniMax-M3', messages: ChatMessage[] }
 *   response { reply: string }
 * The JWT interceptor attaches the auth header automatically.
 */
@Injectable({ providedIn: 'root' })
export class AiChatService {
	#http = inject(HttpClient);
	readonly #url = `${environment.baseURLV2}/ai/chat`;

	send(messages: ChatMessage[]): Observable<string> {
		return this.#http
			.post<{ reply: string }>(this.#url, {
				model: 'MiniMax-M3',
				messages
			})
			.pipe(map((res) => res.reply));
	}
}
